import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'

// Telegram WebApp init
const tg = (window as any).Telegram?.WebApp
if (tg) {
  tg.ready()
  tg.expand()
  // Темна тема під Telegram
  document.documentElement.style.setProperty('--tg-theme-bg-color', tg.themeParams.bg_color || '#0B0F1A')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
